<template>

    <div>
    <v-container style="max-width: 1500px !important">
       <!--  <v-tabs v-model="tab" dark>
                <v-tab v-for="item in items" :key="item.tab">
                    {{ item.tab }}
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item v-for="item in items" :key="item.tab">
                    <v-card flat>
                        <component :is="item.componente" />
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
            <br> -->
            <v-card class="mx-auto my-5 elevation-1 p-4" style="margin-bottom: 1rem !important;">
      <h1>Horario del Personal Médico del Servicio de Diálisis</h1>
  <table>
    <thead>
      <tr>
        <th rowspan="2" class="header-yellow">Sala de Hemodiálisis</th>
        <th rowspan="2" class="activity-column header-size">Actividad</th>
        <th colspan="28">Febrero 2025</th>
      </tr>
      <tr>
        <th>S</th>
        <th>D</th>
        <th>L</th>
        <th>M</th>
        <th>M</th>
        <th>J</th>
        <th>V</th>
        <th>S</th>
        <th>D</th>
        <th>L</th>
        <th>M</th>
        <th>M</th>
        <th>J</th>
        <th>V</th>
        <th>S</th>
        <th>D</th>
        <th>L</th>
        <th>M</th>
        <th>M</th>
        <th>J</th>
        <th>V</th>
        <th>S</th>
        <th>D</th>
        <th>L</th>
        <th>M</th>
        <th>J</th>
        <th>V</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td rowspan="5" class="header-yellow">Dr. Ricardo Medina Milla</td>
        <td class="activity-column">Sala de Hemodiálisis</td>
        <td colspan="2"></td>
        <td class="gray-cell">T</td>
        <td colspan="24"></td>
      </tr>
      <tr>
        <td class="activity-column">Consulta de Hemodiálisis</td>
        <td colspan="4"></td>
        <td class="gray-cell">MT</td>
        <td colspan="22"></td>
      </tr>
      <tr>
        <td class="activity-column">Diálisis Peritoneal</td>
        <td colspan="28"></td>
      </tr>
      <tr>
        <td class="activity-column">Monitoreo Acceso Vascular</td>
        <td colspan="3"></td>
        <td>M</td>
        <td colspan="24"></td>
      </tr>
      <tr>
        <td class="activity-column">Técnico Administrativo</td>
        <td colspan="27"></td>
        <td class="gray-cell">T</td>
      </tr>
      <tr>
        <td rowspan="5" class="header-yellow">Dra. Magda Valencia Yabar</td>
        <td class="activity-column">Sala de Hemodiálisis</td>
        <td></td>
        <td class="gray-cell">GD</td>
        <td class="gray-cell">GN</td>
        <td colspan="25"></td>
      </tr>
      <tr>
        <td class="activity-column">Consulta de Hemodiálisis</td>
        <td colspan="9"></td>
        <td>M</td>
        <td colspan="18"></td>
      </tr>
      <tr>
        <td class="activity-column">Consulta de Admisión</td>
        <td colspan="28"></td>
      </tr>
      <tr>
        <td class="activity-column">Diálisis Peritoneal</td>
        <td colspan="28"></td>
      </tr>
      <tr>
        <td class="activity-column">Monitoreo Acceso Vascular</td>
        <td colspan="2"></td>
        <td class="gray-cell">MT</td>
        <td colspan="25"></td>
      </tr>
      <tr>
        <td class="header-yellow">Vacaciones</td>
        <td colspan="28" class="vacaciones">VACACIONES</td>
      </tr>
    </tbody>
  </table>
</v-card>
    </v-container>
</div>
  </template>
  <style scoped>
  ::v-deep.theme--dark.v-tabs>.v-tabs-bar {
    background: linear-gradient(135deg, rgb(25 115 165), rgb(20 145 215), #0d67aa, #00304e) !important;
}

::v-deep.theme--dark.v-system-bar {
    background: linear-gradient(135deg, rgb(25 115 165), rgb(20 145 215), #0d67aa, #00304e) !important;
}
body {
      font-family: Arial, sans-serif;
    }

    table {
      /* width: 100%; */
      border-collapse: collapse;
     
      border: 1px solid #ccc;
    }

    th, td {
      border: 1px solid #ccc;
      text-align: center;
      padding: 0;
    }

    th {
      background-color: #007bc3;
      color: white;
      padding: 0  !important;
    }

    .header-yellow {
      background-color: #007bc3;
      font-weight: bold;

  width: 15%; /* Ajusta el porcentaje según el ancho que prefieras */
    }
    .header-size {
      background-color: #007bc3;
      font-weight: bold;

  width: 20%; /* Ajusta el porcentaje según el ancho que prefieras */
    }
    .gray-cell {
      background-color: #d9d9d9;
      font-size: .8rem;
    }

    .vacaciones {
      background-color: #f4cccc;
      font-weight: bold;
      text-align: center;
    }

    .activity-column {
      text-align: left;
    }

    td {
      word-wrap: break-word;
    }
    </style>
  <script>
  export default {
    data() {
      return {
        tab: null,
        tab: 0,
        items: [
            { tab: 'Turno', componente: 'Turno' },
            { tab: 'Frecuencia', componente: 'Frecuencia' },
            { tab: 'Serología', componente: 'Serologia' },
            { tab: 'Otros', componente: 'MovimientoPaciente' }
        ],
        headers: [
          { text: "Sala de Hemodiálisis", value: "sala", align: "start" },
          { text: "Actividad", value: "actividad", align: "start" },
          { text: "S", value: "s1" },
          { text: "D", value: "d1" },
          { text: "L", value: "l1" },
          { text: "M", value: "m1" },
          { text: "M", value: "m2" },
          { text: "J", value: "j1" },
          { text: "V", value: "v1" },
          { text: "S", value: "s2" },
        ],
        items: [
          {
            sala: "DR. RICARDO MEDINA MILLA",
            actividad: "Sala de Hemodiálisis",
            dias: ["", "T", "", "", "", "", ""],
          },
          {
            sala: "",
            actividad: "Consulta de Hemodiálisis",
            dias: ["", "", "", "", "MT", "", ""],
          },
          {
            sala: "DRA. MAGDA VALENCIA YABAR",
            actividad: "Sala de Hemodiálisis",
            dias: ["", "GD", "GN", "", "", "", ""],
          },
          {
            sala: "",
            actividad: "Consulta de Admisión",
            dias: ["", "", "", "M", "", "", ""],
          },
          {
            sala: "DRA. HELLEN NÚÑEZ CASTILLO",
            actividad: "Consulta de Hemodiálisis",
            dias: ["GN", "GN", "", "", "", "", ""],
          },
        ],
      };
    },
  };
  </script>
  
  <style scoped>
  .text-center {
    text-align: center;
  }
  </style>